const reportState = {
  reportProperties: {
    usecase_family: [],
    data_sources: [],
    maturity_level: [],
    attack_tactic: [],
    attack_technique: [],
    cis20: [],
    pc1_dss: [],
    s027001: [],
    hipaa: [],
    nist: [],
    severity: [],
    confidence_score: [],
    risk_rate: [],
  },
  name: 'Gaurav',
  executingWorkbookLoaderVisible: false,
  executionResults: [],
  executionTime: 0.0,
  showReportDrawer: true,
}

const reportReducer = (state = reportState, action) => {
  if (action.type === 'UPDATE_PROPERTIES') {
    let oldProperties = Object.assign(state.reportProperties)
    let oldPropertyKeys = Object.keys(oldProperties)
    let newProperties = action.payload
    let newKeys = Object.keys(newProperties)
    for (let i = 0; i < oldPropertyKeys.length; i++)
      for (let j = 0; j < newKeys.length; j++)
        if (oldPropertyKeys[i] === newKeys[j]) {
          if (oldPropertyKeys[i] === 'data_sources') {
            if (oldProperties[oldPropertyKeys[i]].length === 0)
              oldProperties[oldPropertyKeys[i]].push(newProperties[newKeys[j]])
            else oldProperties[oldPropertyKeys[i][0]].push(newProperties[newKeys[j]])
          } else oldProperties[oldPropertyKeys[i]].push(newProperties[newKeys[j]])
        }
    // //console.log(oldProperties)
    return {
      ...state,
      reportProperties: Object.assign(oldProperties),
    }
  }

  /**********ENABLES LOADER**********/
  if (action.type === 'ENABLE_LOADER') {
    return {
      ...state,
      executingWorkbookLoaderVisible: true,
    }
  }

  /************DISABLE LOADER*************/
  if (action.type === 'DISABLE_LOADER') {
    // //console.log(state.reportProperties)
    return {
      ...state,
      name: 'React',
      executingWorkbookLoaderVisible: false,
    }
  }

  if (action.type === 'UPDATE_EXECUTION_DETAILS') {
    return {
      ...state,
      showReportDrawer: true,
    }
  }
  return { ...state }
}

export default reportReducer
